import defaultWidgets from 'data/monitoring/widgets/default.json'
import xpandWidgets from 'data/monitoring/widgets/xpand.json'
import columnStoreWidgets from 'data/monitoring/widgets/cs.json'

export default [
    defaultWidgets,
    xpandWidgets,
    columnStoreWidgets
]
